import React, { useEffect } from 'react'

import { VOLUME_CHECK_EVENTS } from '../StudentVolumeChecksConstants'

import useStudentPreChecks from '../../useStudentPreChecks'
import StudentInstruction from '../../Components/StudentInstruction'
import { PRE_CHECK_MACHINE_STATES } from '../../constants'

export default function TeacherVolumeTestResultSuccess({toggleTeacherMode}) {

  const { logEvent } = useStudentPreChecks({ itemToCheck: PRE_CHECK_MACHINE_STATES.studentSpeechVolumeChecks })

  useEffect(()=> {
    logEvent(VOLUME_CHECK_EVENTS.TEACHER_TEST_SUCCESS)
  }, [])

  const handleContinue = () => {
    toggleTeacherMode()
  }

  return (
    <StudentInstruction>
      <h2>Please let the student try again.</h2>
      <button onClick={handleContinue}>OK</button>
    </StudentInstruction>
  )
}
